 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-en":"lang-en","lang-es":"lang-es","lang-pt":"lang-pt","lang-zh-CN":"lang-zh-CN"}[chunkId]||chunkId) + "." + {"chunk-06832135":"a8761544","chunk-2092e924":"125401a7","chunk-265d421a":"b7490bfd","chunk-2862f762":"ba69b6b2","chunk-550902a2":"2c38e9e3","chunk-a5eb763a":"1f586404","chunk-2d0b6ad6":"9f1e2276","chunk-2d0c96f9":"cd2cb84c","chunk-2efde41c":"a7773be6","chunk-2f3844e8":"451ca820","chunk-d90690bc":"89a45899","chunk-30e2b601":"53bd2790","chunk-338c81b2":"5c7b7c5c","chunk-466ae960":"0a6d93b8","chunk-37306bcc":"8d8805f5","chunk-390136ce":"f024adc3","chunk-87cf18ce":"2da05b7c","chunk-7def7144":"610072cd","chunk-fa68604a":"5e3f2ee4","chunk-401d0265":"0e59d3f1","chunk-45813ada":"c4d5cce3","chunk-45e560ba":"7195204f","chunk-4f374db4":"965b97cb","chunk-adffcf24":"ce3d3f73","chunk-50be1f06":"37f16937","chunk-5529b5e4":"1a4f70e7","chunk-563416de":"7e67383e","chunk-5789bcdc":"51a2cb53","chunk-583a0834":"439dbc27","chunk-59518984":"a4442c3f","chunk-5fef911c":"eb29e5d9","chunk-619e517c":"d75b4b42","chunk-0b3fc655":"c95f2c5e","chunk-0ea6fb50":"4ce28873","chunk-2a50ef36":"a2e45c23","chunk-5e991dee":"424ea26f","chunk-0eebc0b6":"5b216d54","chunk-1c96cd9e":"263cc80f","chunk-2a2733a6":"154f3975","chunk-2bd61530":"d5fdd681","chunk-69e13543":"a231de09","chunk-fb49fe10":"9e06bcab","chunk-365042c7":"73eb9e3f","chunk-63f06dde":"a271a937","chunk-71cf1dd4":"1e48f556","chunk-6831a6c1":"bb1da1da","chunk-2845b666":"e832b396","chunk-0bd846aa":"b182f010","chunk-2f3cd83c":"ee621a32","chunk-3569009e":"99081020","chunk-3f2285b0":"102e2b81","chunk-41e7905e":"5a64450a","chunk-66e037c6":"eb23b381","chunk-6f86f278":"e0bad725","chunk-7a43c806":"6789f38d","chunk-7e45079f":"365f85d7","chunk-8679801a":"32fde4b9","chunk-98fdc822":"c8cf717e","chunk-e4d987fe":"e1cd7953","chunk-3808b6b4":"ab47ac36","chunk-0ab7782e":"bc857df8","chunk-1240ffb5":"825e4f54","chunk-27fa65ee":"6d78ebd2","chunk-6fa93d69":"49d36991","chunk-b2608ea0":"e73b2724","chunk-1ed227df":"0bab483f","chunk-2fd763e4":"f0dc8796","chunk-318146ea":"d10b72f6","chunk-70b9764c":"1df1eb0f","chunk-99297a04":"c3e78607","chunk-7887908c":"4f719069","chunk-d3d4b1e4":"b0856e71","chunk-4e1b6bd8":"d6896529","chunk-12ee9e0a":"9c496c39","chunk-562f95a1":"ce356566","chunk-5c9f1016":"51e38e75","chunk-5d776e8d":"fc4cf603","chunk-cfc767c4":"89c7059e","chunk-70c75b3e":"8ef7a1ac","chunk-75f68215":"792efd67","chunk-ee240342":"2b9a2df5","chunk-efebbd72":"bd513ce2","chunk-4aa9fdc2":"2c399a88","chunk-53ad5351":"24ae61bc","chunk-f4d7fc4c":"2e0dc3cd","chunk-70ab06d9":"fb2a32d7","chunk-657c56c1":"e0d2c951","chunk-1d42d0cd":"462672c5","chunk-69ef3cbc":"7deabb07","chunk-6f08bde0":"323addc3","chunk-72f8287c":"4dce1365","chunk-752e2a9c":"7739a849","chunk-7af3d49b":"f9c91991","chunk-7c039a8c":"49f2d231","chunk-7fc198b3":"46f80718","chunk-8369b7e4":"debec0c2","chunk-8b4969c2":"60781890","chunk-96a4c278":"be435727","chunk-a4d42a1e":"abfc722e","chunk-afacc7da":"c111bd46","chunk-b44c7bf2":"18d9c759","chunk-1bd51f3a":"34c20af3","chunk-241ee77a":"3a60f2a1","chunk-bdb3f636":"0657c010","chunk-bfa6fe80":"f89926c5","chunk-c54236cc":"f3f75888","chunk-d3f3acb8":"9be4e6ca","chunk-0ebf5180":"cd17fa24","chunk-3cd4b108":"4e00c9a8","chunk-7a26038b":"39e3a7fc","chunk-42cc720a":"1c9153fb","chunk-7d560b86":"e1e3b1bd","chunk-c1452c00":"84e48998","chunk-d7a488de":"64a441f5","chunk-f11a9108":"6cb40b12","chunk-1a0377ae":"fc8fca9b","chunk-fac408a0":"69947fef","lang-en":"eb2e7de0","lang-es":"11e23c5a","lang-pt":"b8fbc35f","lang-zh-CN":"f4eec157","chunk-8f02821a":"c960e132","chunk-0d5420af":"5d189c53","chunk-34abee0c":"ceb2d4b9","chunk-b5f62efe":"bd3b71e7","chunk-2652bea4":"1feed64c","chunk-49140c10":"1417f87d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-06832135":1,"chunk-2092e924":1,"chunk-265d421a":1,"chunk-2862f762":1,"chunk-2efde41c":1,"chunk-2f3844e8":1,"chunk-d90690bc":1,"chunk-30e2b601":1,"chunk-338c81b2":1,"chunk-466ae960":1,"chunk-37306bcc":1,"chunk-390136ce":1,"chunk-87cf18ce":1,"chunk-7def7144":1,"chunk-fa68604a":1,"chunk-401d0265":1,"chunk-45813ada":1,"chunk-45e560ba":1,"chunk-4f374db4":1,"chunk-adffcf24":1,"chunk-50be1f06":1,"chunk-5529b5e4":1,"chunk-563416de":1,"chunk-5789bcdc":1,"chunk-583a0834":1,"chunk-59518984":1,"chunk-5fef911c":1,"chunk-619e517c":1,"chunk-0b3fc655":1,"chunk-0ea6fb50":1,"chunk-2a50ef36":1,"chunk-5e991dee":1,"chunk-0eebc0b6":1,"chunk-1c96cd9e":1,"chunk-2a2733a6":1,"chunk-2bd61530":1,"chunk-69e13543":1,"chunk-fb49fe10":1,"chunk-365042c7":1,"chunk-63f06dde":1,"chunk-71cf1dd4":1,"chunk-6831a6c1":1,"chunk-2845b666":1,"chunk-0bd846aa":1,"chunk-2f3cd83c":1,"chunk-3569009e":1,"chunk-3f2285b0":1,"chunk-41e7905e":1,"chunk-66e037c6":1,"chunk-6f86f278":1,"chunk-7a43c806":1,"chunk-7e45079f":1,"chunk-8679801a":1,"chunk-98fdc822":1,"chunk-e4d987fe":1,"chunk-3808b6b4":1,"chunk-0ab7782e":1,"chunk-1240ffb5":1,"chunk-27fa65ee":1,"chunk-6fa93d69":1,"chunk-b2608ea0":1,"chunk-1ed227df":1,"chunk-2fd763e4":1,"chunk-318146ea":1,"chunk-70b9764c":1,"chunk-99297a04":1,"chunk-7887908c":1,"chunk-d3d4b1e4":1,"chunk-4e1b6bd8":1,"chunk-12ee9e0a":1,"chunk-562f95a1":1,"chunk-5c9f1016":1,"chunk-5d776e8d":1,"chunk-cfc767c4":1,"chunk-70c75b3e":1,"chunk-75f68215":1,"chunk-ee240342":1,"chunk-efebbd72":1,"chunk-4aa9fdc2":1,"chunk-53ad5351":1,"chunk-f4d7fc4c":1,"chunk-70ab06d9":1,"chunk-657c56c1":1,"chunk-1d42d0cd":1,"chunk-69ef3cbc":1,"chunk-6f08bde0":1,"chunk-72f8287c":1,"chunk-752e2a9c":1,"chunk-7af3d49b":1,"chunk-7c039a8c":1,"chunk-7fc198b3":1,"chunk-8369b7e4":1,"chunk-8b4969c2":1,"chunk-96a4c278":1,"chunk-a4d42a1e":1,"chunk-afacc7da":1,"chunk-b44c7bf2":1,"chunk-1bd51f3a":1,"chunk-241ee77a":1,"chunk-bdb3f636":1,"chunk-bfa6fe80":1,"chunk-c54236cc":1,"chunk-d3f3acb8":1,"chunk-0ebf5180":1,"chunk-3cd4b108":1,"chunk-7a26038b":1,"chunk-42cc720a":1,"chunk-7d560b86":1,"chunk-c1452c00":1,"chunk-d7a488de":1,"chunk-f11a9108":1,"chunk-1a0377ae":1,"chunk-fac408a0":1,"chunk-8f02821a":1,"chunk-0d5420af":1,"chunk-34abee0c":1,"chunk-b5f62efe":1,"chunk-2652bea4":1,"chunk-49140c10":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-en":"lang-en","lang-es":"lang-es","lang-pt":"lang-pt","lang-zh-CN":"lang-zh-CN"}[chunkId]||chunkId) + "." + {"chunk-06832135":"68203507","chunk-2092e924":"d571f524","chunk-265d421a":"9e9b21f8","chunk-2862f762":"24da8235","chunk-550902a2":"31d6cfe0","chunk-a5eb763a":"31d6cfe0","chunk-2d0b6ad6":"31d6cfe0","chunk-2d0c96f9":"31d6cfe0","chunk-2efde41c":"bd3d12ac","chunk-2f3844e8":"cad4b3b8","chunk-d90690bc":"7b40dc8c","chunk-30e2b601":"2cefb08b","chunk-338c81b2":"5767cc8a","chunk-466ae960":"9847677c","chunk-37306bcc":"37de909b","chunk-390136ce":"20f4b591","chunk-87cf18ce":"3dfcd5c3","chunk-7def7144":"be2a431b","chunk-fa68604a":"aa563f35","chunk-401d0265":"a85ea77a","chunk-45813ada":"46917cb5","chunk-45e560ba":"4d14e3f2","chunk-4f374db4":"d9b4e4b0","chunk-adffcf24":"dd8bc02e","chunk-50be1f06":"96c680f4","chunk-5529b5e4":"31af8ba7","chunk-563416de":"a4a0fd5f","chunk-5789bcdc":"7a1f96b3","chunk-583a0834":"7a2cdb23","chunk-59518984":"a09c889b","chunk-5fef911c":"92a3651a","chunk-619e517c":"f9fdb384","chunk-0b3fc655":"100c8a28","chunk-0ea6fb50":"e441937a","chunk-2a50ef36":"7944af09","chunk-5e991dee":"530bb04a","chunk-0eebc0b6":"b074317d","chunk-1c96cd9e":"e3350f8d","chunk-2a2733a6":"b834b88e","chunk-2bd61530":"10afa31d","chunk-69e13543":"f4628f0e","chunk-fb49fe10":"c76ee962","chunk-365042c7":"4e5b88be","chunk-63f06dde":"aed27705","chunk-71cf1dd4":"a1f67bb6","chunk-6831a6c1":"0def483c","chunk-2845b666":"f8034f2c","chunk-0bd846aa":"afbaba1f","chunk-2f3cd83c":"96e56b0b","chunk-3569009e":"0a48e4b6","chunk-3f2285b0":"4c4efcda","chunk-41e7905e":"0f8f5ec3","chunk-66e037c6":"57582277","chunk-6f86f278":"f2425f01","chunk-7a43c806":"d4fbcde0","chunk-7e45079f":"0f40fbde","chunk-8679801a":"cdf2db6b","chunk-98fdc822":"393cb613","chunk-e4d987fe":"fac3865b","chunk-3808b6b4":"5dc85e78","chunk-0ab7782e":"167b29ca","chunk-1240ffb5":"f84183bf","chunk-27fa65ee":"247d39dd","chunk-6fa93d69":"89fd5e0a","chunk-b2608ea0":"e31c08f8","chunk-1ed227df":"4de5b5d5","chunk-2fd763e4":"943e3bec","chunk-318146ea":"7ab7fe90","chunk-70b9764c":"21dad724","chunk-99297a04":"09ddd1bc","chunk-7887908c":"70ea3894","chunk-d3d4b1e4":"da036708","chunk-4e1b6bd8":"c8109b24","chunk-12ee9e0a":"91779ddc","chunk-562f95a1":"414a353c","chunk-5c9f1016":"c7bae9ae","chunk-5d776e8d":"91810b4c","chunk-cfc767c4":"0b03d687","chunk-70c75b3e":"15c519f2","chunk-75f68215":"e7a48a23","chunk-ee240342":"e2880ab9","chunk-efebbd72":"2ef4161a","chunk-4aa9fdc2":"79483768","chunk-53ad5351":"eeb87b89","chunk-f4d7fc4c":"03893ee8","chunk-70ab06d9":"980a2197","chunk-657c56c1":"3cb404f6","chunk-1d42d0cd":"673ad3bf","chunk-69ef3cbc":"dd201c2e","chunk-6f08bde0":"76afd7c7","chunk-72f8287c":"1e20953a","chunk-752e2a9c":"a75891c4","chunk-7af3d49b":"3481e631","chunk-7c039a8c":"065c8d7b","chunk-7fc198b3":"c2be7b91","chunk-8369b7e4":"867c99c3","chunk-8b4969c2":"12789c67","chunk-96a4c278":"f2f64075","chunk-a4d42a1e":"a2d07b58","chunk-afacc7da":"ff218d41","chunk-b44c7bf2":"311a6389","chunk-1bd51f3a":"19f57f3f","chunk-241ee77a":"e314f6ea","chunk-bdb3f636":"08f4a06b","chunk-bfa6fe80":"58b47bd4","chunk-c54236cc":"c2f6a27f","chunk-d3f3acb8":"8a1752fa","chunk-0ebf5180":"5105b6db","chunk-3cd4b108":"5105b6db","chunk-7a26038b":"6a75abe1","chunk-42cc720a":"c890a5ee","chunk-7d560b86":"54d250cb","chunk-c1452c00":"b8fb06b5","chunk-d7a488de":"b7b640c7","chunk-f11a9108":"3651ab7b","chunk-1a0377ae":"56c875d9","chunk-fac408a0":"ef8ae85f","lang-en":"31d6cfe0","lang-es":"31d6cfe0","lang-pt":"31d6cfe0","lang-zh-CN":"31d6cfe0","chunk-8f02821a":"48e3ff27","chunk-0d5420af":"523e3cad","chunk-34abee0c":"cb0fed8a","chunk-b5f62efe":"f61af3cd","chunk-2652bea4":"f36bd067","chunk-49140c10":"c6950b21"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
